import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';
import useDeleteCandidateFormItem from '@/features/agent/form/api/useDeleteCandidateFormItem';
import { showErrorToast, showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** 削除対象項目のタイトル（確認文で表示） */
  itemTitle: string;
  candidateFormId: number;
  candidateFormItemId: number;
  /** 削除成功時に呼ばれる */
  onDeleted?: () => void;
};

export default function DeleteItemDialog({
  open,
  onOpenChange,
  itemTitle,
  candidateFormId,
  candidateFormItemId,
  onDeleted,
}: Props) {
  const { mutateAsync: deleteItem, isPending: isDeleting } = useDeleteCandidateFormItem();

  const handleDelete = async () => {
    try {
      await deleteItem({
        candidateFormId,
        candidateFormItemId,
      });
      showSuccessToast('削除しました');
      onOpenChange(false);
      onDeleted?.();
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '削除に失敗しました';
      showErrorToast(errorMessage);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>項目の削除</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-lg">
          <AlertDialogDescription>
            「{itemTitle}」を削除しますか？この操作は取り消せません。
          </AlertDialogDescription>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button color="secondary" size="md">
              キャンセル
            </Button>
          </AlertDialogCancel>
          <Button color="danger" size="md" onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
